import { AcademyFloatingState } from 'store/modules/academy_store/types';

// Preferência do vídeo flutuante persistida POR live (id), no localStorage.
// Assim o estado (expandido/minimizado) sobrevive ao reload, mas uma live nova
// sempre começa expandida (não herda o "minimizado" de uma live anterior).
const key = (liveId: number) => `academyFloating:${liveId}`;

export const getFloatingPref = (liveId: number): AcademyFloatingState => {
  try {
    return localStorage.getItem(key(liveId)) === 'minimized' ? 'minimized' : 'expanded';
  } catch {
    return 'expanded';
  }
};

export const setFloatingPref = (liveId: number, value: AcademyFloatingState): void => {
  try {
    localStorage.setItem(key(liveId), value);
  } catch {
    // ignore (localStorage indisponível)
  }
};
